import { useAppCategories } from './useAppCategories';

export interface BlockedApp {
  id: string;
  name: string;
  icon: string;
  bundleId: string;
  source: 'device' | 'level';
}

export const useBlockedApps = () => {
  const { deviceAppConfig, blockedApps: blockedAppsRaw, isLoading } = useAppCategories();

  // appFilter === true means Open App Store / blacklist mode (Apple App Store)
  const appFilter = deviceAppConfig?.appFilter;
  const hasAppleAppStore = appFilter === true;

  const blockedApps: BlockedApp[] = blockedAppsRaw.map(app => ({
    id: app.id,
    name: app.name,
    icon: app.iconUrl,
    bundleId: app.bundleId,
    source: 'device' as const,
  }));

  return {
    blockedApps,
    hasAppleAppStore,
    isLoading,
    isLoadingConfig: isLoading,
    deviceAppConfig,
  };
};
